import { Form, SelectProps } from "antd";
import { useEffect, useState } from "react";

import { _isRequired, parseErrorMessage, renderCountryListOptions } from "utils";
import { CountryCodeGridDto } from "interfaces";
import { SearchSelect } from "ui";
import { getCountryList } from "services";
import styles from "utils/form/styles.module.css";

interface IProps {
  inputProps: SelectProps;
  name: string | string[];
}

export const CountryCodeSelect = (props: IProps) => {
  const { inputProps, name } = props;
  const form = Form.useFormInstance();
  const [countries, setCountries] = useState<CountryCodeGridDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      await getCountryList({ size: 10000, sort: ["countryCode,asc"] })
        .then((res) => {
          if (res.content) {
            setCountries(res.content);
          }
        })
        .catch((e) => {
          console.error(parseErrorMessage(e));
        })
        .finally(() => setLoading(false));
    };

    fetchCountries();
  }, []);

  const handleChange = async (value: string) => {
    const currentCountry = countries.find((item) => item.countryCode === value);
    if (currentCountry) {
      form.setFieldValue("counterpartyCountry", currentCountry.country);
    }
  };

  return (
    <Form.Item name={name} rules={[_isRequired("Выберите страну контрагента")]} className="full-width">
      <SearchSelect
        {...inputProps}
        onChange={handleChange}
        loading={loading}
        placeholder="Страна контрагента"
        disabled={inputProps.disabled || loading}
        optionLabelProp="label"
      >
        {renderCountryListOptions(countries)}
      </SearchSelect>
    </Form.Item>
  );
};
